// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1897":"css/app.7035","5176":"css/admin-app.7035"}[chunkId] + ".css";
};